// Should match values in router/routes.constants.ts but updating here as we move things to ui library
export enum SHARED_ROUTE_NAMES {
  CDRS = 'CDRs',

  // Locations
  LOCATIONS = 'Locations',
  EDIT_LOCATION = 'Edit Location',
  // Users
  USER_SUBSCRIPTIONS = 'User Notifications Subscriptions',
}
